
import { iconsImgs } from "../../utils/icons";
import { useContext, useEffect, useState } from "react";
import "./AddFriends.scss";
import Header from "../Header";
import { Friendship } from "../../types"
import { useLocation, useNavigate } from 'react-router-dom';
import AddFriendsOptionsModal from "./Modals/AddFriendsOptionsModal";
import AuthClient from "../../api/AuthClient";
import AddFriendsApi from "../../api/AddFriendsApi";
import Gender from "../../api/enums/Gender";
import { routes } from "../../routes/routes";
import { PartiesContext } from "../../GlobalContext/partiesContext";
import { syncMyPartiesAndSelectedPartyFromGroupId } from "../../utils/fetchAndSetMyPartiesInfo";
import { getGuestDisplayName } from "../../utils/guestDisplayName";

const FriendsAge = () => {

    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);

    const [showOverAgeModal, setOverAgeModal] = useState(false);
    const handleOverAgeCloseModal = () => setOverAgeModal(false);

    const [friendsStateData, setFriends] = useState<Friendship>({
        Friends: [],
        GroupId: "",
    });

    const location = useLocation();
    const { friendsState } = location.state;
    const navigate = useNavigate();
    const { setMyPartiesInfoContextData, setSelectedPartyContextData } = useContext(PartiesContext);
    const [isSavingFriends, setIsSavingFriends] = useState(false);

    useEffect(() => {
        if (friendsState.Friends.length > 0) {
            setFriends(friendsState);
        }
    }, [friendsState])

    const handleAgeChange = (event: React.ChangeEvent<HTMLInputElement>, userIndex: number) => {

        const { name, value } = event.target;

        const digitsOnly = value.replace(/\D/g, "").slice(0, 3);
        const age = digitsOnly === "" ? 0 : parseInt(digitsOnly, 10);
        const today = new Date();
        const yesterday = new Date(today.getTime());

        yesterday.setDate(yesterday.getDate() - 1);
        const dob = new Date(yesterday.getFullYear() - age, yesterday.getMonth(), yesterday.getDate());

        setFriends((prevFriendsState) => {
            const updatedFriends = [...prevFriendsState.Friends];
            updatedFriends[userIndex] = {
                ...updatedFriends[userIndex],
                [name]: age,
                "DateOfBirth": dob
            };

            return {
                ...prevFriendsState,
                Friends: updatedFriends,
            };
        });
    }

    async function verifyFriends() {
        if (isSavingFriends) {
            return;
        }

        if (friendsStateData?.Friends.some(item => item.Age === 0) || friendsStateData?.Friends.some(item => Number.isNaN(item.Age)) ||
            friendsStateData?.Friends.some(item => item.Age < 18)) {
            setShowModal(true);
        } else if (!friendsStateData?.Friends.some(item => item.Age < 18) && !friendsStateData?.Friends.some(item => item.Age > 90)) {

            const authClient = new AuthClient();
            const addFriendsApi = new AddFriendsApi(authClient);

            try {
                setIsSavingFriends(true);
                const result = await addFriendsApi.addFriends(friendsStateData);

                if (result.statusCode === 200) {
                    await syncMyPartiesAndSelectedPartyFromGroupId(
                        authClient,
                        friendsStateData.GroupId,
                        setSelectedPartyContextData,
                        setMyPartiesInfoContextData
                    );
                    navigate(routes.MyPartyWithId(friendsStateData.GroupId), { replace: true });
                } else {
                    alert("Failed to add friends. Please try again.");
                }
            } finally {
                setIsSavingFriends(false);
            }

        } else {
            setOverAgeModal(true);
        }
    }

    return (
        <>
            <AddFriendsOptionsModal showModal={false} handleCloseModal={() => { }} showAgeWarningModal={showModal} handleCloseAgeWarningModal={handleCloseModal}
                showOverAgeWarningModal={showOverAgeModal} handleCloseOverAgeWarningModal={handleOverAgeCloseModal} />
            <Header />
            <div className="centerGroup">
                <div className="desktopUI">
                    {friendsStateData?.Friends.length > 0 ? (
                        <>
                            <div className="row">
                                <div className="d-flex justify-content-start space col-6 mb-1">
                                    <button className='BtnTop yellowTxt btn backBtn' onClick={() => navigate(-1)} disabled={isSavingFriends}>Back</button>
                                </div>

                                <div className="d-flex justify-content-end col-6 space">
                                    <button className="BtnTop whiteTxt btn" onClick={verifyFriends} disabled={isSavingFriends} >
                                        {isSavingFriends ? "Saving..." : "Done"}
                                    </button>
                                </div>
                            </div>

                            <p className="d-flex yellowTxt justify-content-center _fp">
                                Age?
                            </p>

                            <div className="container">
                                {friendsStateData.Friends.map((item, index) => (
                                    <div key={index} className="friend-container">
                                        <div className="image-container">
                                            <img src={item.Gender === Gender.Female ? iconsImgs.Girl : iconsImgs.Boy} className="f_Img" alt={`${getGuestDisplayName(item)} avatar`} />
                                        </div>

                                        <div className="content_ text-start">
                                            <p className="whiteTxt f_name mb-0">{getGuestDisplayName(item)}</p>

                                            <div className="input-container">
                                                <input
                                                    name="Age"
                                                    type="text"
                                                    inputMode="numeric"
                                                    autoComplete="off"
                                                    maxLength={3}
                                                    value={item.Age === 0 ? "" : String(item.Age)}
                                                    onChange={(event) => { handleAgeChange(event, index) }}
                                                    className="inp inp_"
                                                    placeholder="Enter Age"
                                                    disabled={isSavingFriends}
                                                />
                                                <span className="text-after-input whiteTxt">years</span>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="container">
                                <button className="doneBtn yellowTxt" onClick={verifyFriends} disabled={isSavingFriends}>
                                    {isSavingFriends ? "Saving..." : "Done"}
                                </button>
                            </div>
                        </>
                    ) : (
                        <p>
                            No friends were found!
                        </p>
                    )}

                </div>
            </div >
        </>
    );
};

export default FriendsAge;
